module.exports = __webpack_public_path__ + "img/logo-transporte-correto.ca031865.png";